import Rails from "@rails/ujs";
Rails.start()
window.Rails = Rails;

import './add_tether'
import './add_jquery'
import 'jquery-ui-dist/jquery-ui'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-datepicker/js/bootstrap-datepicker'
import 'medium-editor/dist/js/medium-editor'

import 'selectize'

import './main'

import './vendor/frontend/jquery.gridder/jquery.gridder'
import './vendor/frontend/jquery.scrollTo/jquery.scrollTo'
import './vendor/frontend/superfish/hoverIntent'
import './vendor/frontend/superfish/superfish'
import './vendor/frontend/jquery.validate.min'
import './vendor/frontend/sly'

import 'chart.js'

import './cookies-eu-banner'

import './helpers/element_exists'
import './helpers/is-mobile'
import './helpers/jquery.easings'
import './helpers/jquery.smartresize'
import './helpers/string-helpers'

import './behaviors/_chart-config'
import './behaviors/bar-chart'
import './behaviors/equal-height'
import './behaviors/expand-content'
import './behaviors/form-disclaimer'
import './behaviors/pie-chart'
import './behaviors/region-office-loader'
import './behaviors/searchbar'
import './behaviors/stacked-line-chart'
import './behaviors/switch-contact'
import './behaviors/tracking-helper'
import './behaviors/vertical-center'

import './vendor/google/autotrack'
import './vendor/jquery.scrollTo/jquery.scrollTo'
import './vendor/superfish/hoverIntent'
import './vendor/superfish/superfish'

import './frontend/library-page'
import './frontend/main-nav'
import './frontend/tender-page'
import './frontend/training-page'
import './frontend/vacancy'

import './modules/contact-form'